<template>
	<div id="cadasterannex-editor"
		 class="app-home ui-styles"
		 :class="theme">

		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :filesOpen="filesOpen" :fileOpen="fileOpen" :reportOpen="reportOpen"></side-nav-bar>
				<div class="app-container">
					<bar>
					</bar>
					<h1><span>{{ $t('Annex') }} "{{ cadasterannex.filename }}"</span><span v-if="cadasterannex.dirty">*</span></h1>
					<message
							v-if="cadasterannex.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<div class="datedata">
						<p class="small">{{ $t('Created') }}: {{ millis_to_time(cadasterannex.date_created)
							}}</p>
						<p class="small">{{ $t('Last_modified')
							}}: {{ millis_to_time(cadasterannex.date_modified) }}</p>
					</div>

					<vue-tabs>
						<v-tab :title="data_text">
							<div class="tab_content">
								<form class="bt-form">
									<div class="section-container">
										<div class="field-container">
											<div v-if="cadasterannex.url">
												<img :src="cadasterannex.url" width="600px"
													 height="auto">
											</div>
										</div>
									</div>
									<div class="section-container">
										<h3>{{ $t('File_name') }} </h3>
										<div class="field-container">
											<div class="field__group">
												<label class="field__group__label">{{ $t('File_name') }}</label>
												<span>{{ cadasterannex.filename }}</span>
											</div>
										</div>
										<!--
										<div class="field-container">
											<div class="field__group">
												<label class="field__group__label">URL</label>
												<span>{{ cadasterannex.url }}</span>
											</div>
										</div>
										-->
									</div>
									<div class="section-container">
										<h3>{{ $t('Image_footer') }} </h3>


										<div class="field-container" v-if="cadasterannex.name_ca || currentLocale === 'ca'">
											<div class="field__group">
												<label class="field__group__label">{{ $t('Image_footer') }} {{ $t('in') }} {{ $t('Catalan') }}</label>
												<input class="field__group__input"
													   type="text"
													   spellcheck="false"
													   v-model="cadasterannex.name_ca"
													   @input="set_cadasterannex_name_ca">
											</div>
										</div>
										<div class="field-container" v-if="cadasterannex.name_en || currentLocale === 'en'">
											<div class="field__group">
												<label class="field__group__label">{{ $t('Image_footer') }} {{ $t('in') }} {{ $t('English') }}</label>
												<input class="field__group__input"
													   type="text"
													   spellcheck="false"
													   v-model="cadasterannex.name_en"
													   @input="set_cadasterannex_name_en">
											</div>
										</div>
										<div class="field-container" v-if="cadasterannex.name_es || currentLocale === 'es'">
											<div class="field__group">
												<label class="field__group__label">{{ $t('Image_footer') }} {{ $t('in') }} {{ $t('Spanish') }}</label>
												<input class="field__group__input"
													   type="text"
													   spellcheck="false"
													   v-model="cadasterannex.name_es"
													   @input="set_cadasterannex_name_es">
											</div>
										</div>
									</div>
								</form>
							</div>
						</v-tab>
						<v-tab :title="metadata_text">
							<div class="tab_content">
								<form class="bt-form">

								</form>
							</div>
						</v-tab>
					</vue-tabs>

					<div>
						<div @click.prevent="onGoUp" style="width: fit-content; margin-left: auto">
							<icon-button icon="chevron-left" :text="goup_button_text"
										 icon_color="black"
										 text_color="black" border_color="lightgray"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentCadasterAnnex({go_up: false})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentCadasterAnnex({go_up: true})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_and_go_up_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<message
							v-if="cadasterannex.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<!--
					<bar>
					</bar>
-->
				</div>
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import { dateMixin, localStorageMixin, objectsMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'cadasterannex-editor',

        mixins: [
            dateMixin,
            localStorageMixin,
            objectsMixin
        ],

        data: () => ({
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: Vue.i18n.translate('Metadata'),
            data_text: Vue.i18n.translate('Data'),
            report_title_error_text: Vue.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: Vue.i18n.translate('Add_real_estate'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
            pdf_button_text: Vue.i18n.translate('Print_report_in_PDF'),
            save_button_text: Vue.i18n.translate('Save'),
            save_and_go_up_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: Vue.i18n.translate('Actions'),
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            discard_text: Vue.i18n.translate('Discard'),
            openlink_text: Vue.i18n.translate('Open_link_in_new_tab'),
        }),

        created () {
                    this.master_loading = false
        },

        components: {
            Bar,
            Message,
            IconButton,
            Spinner,
            SideNavBar,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator
        },

        computed: {
            ...mapGetters([
                'theme',
                'tags_display',
                'currentLocale',
                'cadasterannex',
            ])
        },

        methods: {
            ...mapActions(
                [
                    'UPDATE_CADASTERANNEX',

                    'SET_CADASTERANNEX_NAME_CA',
                    'SET_CADASTERANNEX_NAME_EN',
                    'SET_CADASTERANNEX_NAME_ES',
                ]),
            set_cadasterannex_name_ca: _.debounce(function (e) {
                this.SET_CADASTERANNEX_NAME_CA(e.target.value)
            }, 1000),
            set_cadasterannex_name_en: _.debounce(function (e) {
                this.SET_CADASTERANNEX_NAME_EN(e.target.value)
            }, 1000),
            set_cadasterannex_name_es: _.debounce(function (e) {
                this.SET_CADASTERANNEX_NAME_ES(e.target.value)
            }, 1000),
            set_cadasterannex: _.debounce(function (e) {
                this.SET_CADASTERANNEX_NAME_CA(e.name_ca)
                this.SET_CADASTERANNEX_NAME_EN(e.name_en)
                this.SET_CADASTERANNEX_NAME_ES(e.name_es)
            }, 0),
            onSaveCurrentCadasterAnnex: function (data) {
                this.UPDATE_CADASTERANNEX({
                    object: this.cadasterannex,
                    path: this.cadasterannex.path,
                    parent_path: this.cadasterannex.parent_path,
                    key: this.cadasterannex.id
                }).then((res) => {
                    // router.go(-1)
                    if (data.go_up) {
                        this.onGoUp()
                    }
                })
            },
            onGoBack: function () {
                router.go(-1)
            },
            onGoUp: function () {
                router.go(-1)
            }
        },
        head: {
            title: {
                inner: 'Edit cadasterannex'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// CadasterAnnexEditor.vue?0f5605b5